import React from 'react';
import Button from '../../../components/ui/Button';

const QuickActions = ({ onUploadDocument, onCreateDocumentBase, onAdvancedSearch }) => {
  const quickActions = [
    {
      id: 'upload',
      label: 'Upload Document',
      icon: 'Upload',
      variant: 'default',
      onClick: onUploadDocument,
      description: 'Add new documents to the system'
    },
    {
      id: 'create-base',
      label: 'Create Document Base',
      icon: 'FolderPlus',
      variant: 'outline',
      onClick: onCreateDocumentBase,
      description: 'Set up a new document collection'
    },
    {
      id: 'search',
      label: 'Advanced Search',
      icon: 'Search',
      variant: 'ghost',
      onClick: onAdvancedSearch,
      description: 'Find documents with detailed filters'
    }
  ];

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold text-foreground mb-4">Quick Actions</h3>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        {quickActions?.map((action) => (
          <div key={action?.id} className="text-center">
            <Button
              variant={action?.variant}
              size="lg"
              iconName={action?.icon}
              iconPosition="left"
              onClick={action?.onClick}
              className="w-full mb-2"
            >
              {action?.label}
            </Button>
            <p className="text-xs text-muted-foreground">{action?.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default QuickActions;